import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [canEdit, setCanEdit] = useState(false);
    const [canCreate, setCanCreate] = useState(false);

    const InitialData = {
        exam_id: "",
        coupon_code: "",
        discount_type: "",
        discount_value: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [ExamData, setExamData] = useState([]);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/coupons/fetchSingle", filter);
        const CouponData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: CouponData["id"],
                exam_id: CouponData["exam_id"],
                coupon_code: CouponData["coupon_code"],
                discount_type: CouponData["discount_type"],
                discount_value: CouponData["discount_value"],
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    const fetchExamData = async () => {
        const filter = { id: store_data?.org_id }
        const response = await postAPI("/exams/list", filter);
        if (response?.status) {
            const ExamList = []
            for (let index = 0; index < response?.data?.length; index++) {
                ExamList.push({
                    label: response?.data[index]?.exam_title,
                    value: response?.data[index]?.id
                })
            }
            setExamData(ExamList)
            setLoading(false)
        } else {
            setExamData([])
            setLoading(false)
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("SETTINGS", "Coupons", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "Coupons", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();
        
        fetchExamData();
        setLoading(false)
        if(is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])


    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) {
            return;
        }
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        // console.log(FormData)
        const payload = { org_id: store_data?.org_id, ...FormData }
        const response = await postAPI(is_edit ? "/coupons/update" : "/coupons/create", payload);
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('New Coupon Added Successfully.');
            window.location.reload();
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {
                Loading ?
                    <Loader />
                    :
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div class="col-12 col-md-6 mt-0">
                            <SelectBoxHandler Label="Exam" Options={ExamData} Name="exam_id" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="coupon_code" Type="text" Label="Coupon Code" />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <SelectBoxHandler Label="Discount Type" Options={[{"label": "Percentage", "value": "PERCENTAGE"}, {"label": "Amount", "value": "AMOUNT"}]} Name="discount_type" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                        </div>
                        <div class="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="discount_value" Type="number" Label="Discount Value" />
                        </div>
                    </FormSubmissionHandler>
            }
            <ToastContainer  position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
